import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

import type { FirstRunExperienceDialogProps } from './FirstRunExperienceDialog';

const firstRunExperienceDialog = () => import(/* webpackChunkName: "4-feat-fre" */ './FirstRunExperienceDialog');

export default lazyLoadOnRender<FirstRunExperienceDialogProps>({ loader: firstRunExperienceDialog });
